import React from 'react';
import { ChevronDown, Car, Calendar, Wrench, Award, MapPin, Clock } from 'lucide-react';
import { Button } from './ui/button';

export const Hero = ({ dealership }) => {
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const uspItems = [
    { icon: Clock, text: 'Über 35 Jahre Erfahrung' },
    { icon: MapPin, text: '3 Standorte in Magdeburg' },
    { icon: Car, text: '150+ Fahrzeuge verfügbar' },
    { icon: Award, text: 'Nissan, Mazda, Omoda & Jaecoo Partner' },
  ];

  return (
    <section
      id="hero"
      className="relative min-h-screen flex flex-col justify-center overflow-hidden"
    >
      {/* Background Image with Overlay */}
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage:
            'url(https://customer-assets.emergentagent.com/job_wilke-auto-portal/artifacts/slnozb7t_header.jpg)',
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-br from-black/40 via-black/30 to-black/50"></div>
      </div>

      {/* Animated Gradient Overlay */}
      <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-black/40"></div>

      {/* Content */}
      <div className="relative z-10 text-center px-4 sm:px-6 lg:px-8 max-w-5xl mx-auto pt-24 pb-8">
        <div className="animate-fade-in-up">
          <div className="flex justify-center mb-8">
            <div className="bg-white/40 backdrop-blur-sm px-6 py-4 rounded-xl">
              <img
                src="https://customer-assets.emergentagent.com/job_wilke-auto-portal/artifacts/sdbsg346_fixed_autohaus-wilke.ai_black.png"
                alt="Autohaus Wilke Logo - Ihr Nissan und Mazda Händler in Magdeburg"
                className="h-32 sm:h-40 lg:h-48 w-auto object-contain"
                style={{ 
                  maxWidth: '500px'
                }}
              />
            </div>
          </div>
          <div className="bg-black/30 backdrop-blur-md px-8 py-6 rounded-2xl mx-auto max-w-4xl">
            <p className="text-xl sm:text-2xl lg:text-3xl text-white mb-4 font-light">
              {dealership.tagline}
            </p>
            <p className="text-lg sm:text-xl text-gray-100 mb-4 leading-relaxed">
              {dealership.description}
            </p>
          </div>

          {/* CTA Buttons - Erweitert */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mt-8">
            <a href="/fahrzeugbestand.html">
              <Button
                className="bg-red-600 hover:bg-red-700 text-white px-8 py-6 text-lg font-semibold rounded-lg shadow-2xl transition-all duration-300 hover:scale-105 hover:shadow-red-600/50 flex items-center gap-2"
              >
                <Car className="w-5 h-5" />
                Fahrzeugbestand ansehen
              </Button>
            </a>
            <a href="/werkstatt.html">
              <Button
                variant="outline"
                className="border-2 border-white text-white hover:bg-white hover:text-gray-900 px-8 py-6 text-lg font-semibold rounded-lg shadow-2xl transition-all duration-300 hover:scale-105 backdrop-blur-sm bg-black/20 flex items-center gap-2"
              >
                <Wrench className="w-5 h-5" />
                Werkstatt-Termin
              </Button>
            </a>
            <Button
              onClick={() => scrollToSection('kontakt')}
              variant="outline"
              className="border-2 border-white text-white hover:bg-white hover:text-gray-900 px-8 py-6 text-lg font-semibold rounded-lg shadow-2xl transition-all duration-300 hover:scale-105 backdrop-blur-sm bg-black/20 flex items-center gap-2"
            >
              <Calendar className="w-5 h-5" />
              Probefahrt anfragen
            </Button>
          </div>
        </div>
      </div>

      {/* USP-Leiste */}
      <div className="relative z-10 mt-auto mb-16">
        <div className="max-w-6xl mx-auto px-4">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
            {uspItems.map((item, index) => (
              <div
                key={index}
                className="bg-white/10 backdrop-blur-md rounded-xl px-4 py-4 flex items-center gap-3 border border-white/20 hover:bg-white/20 transition-all duration-300"
              >
                <div className="w-10 h-10 bg-red-600 rounded-lg flex items-center justify-center flex-shrink-0">
                  <item.icon className="w-5 h-5 text-white" />
                </div>
                <span className="text-white font-medium text-sm sm:text-base">{item.text}</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 z-20 animate-bounce">
        <ChevronDown className="w-8 h-8 text-white drop-shadow-lg" />
      </div>
    </section>
  );
};
